import Thankyou from "../../components/ThankYou/Thankyou";
import { getPassportScanData } from "../../store/Checkin/Scan/scanPassportSlice";
import { getModuleConfiguration } from "../../store/Checkin/moduleConfigurationSlice";
import { useSelector, useDispatch } from "react-redux";
import { STEP_MASTER_ENUM } from "../../constants/constant";
import { getStepMaster, getParametersFromLocalStorage } from "../../helpers/commonHelper";
import { useEffect } from "react";
import { postStageDetails } from "../../store/stageSlice";

const ThankyouPassportScan = () => {
  const userData = useSelector(getPassportScanData);
  const roomPin = localStorage.getItem("RoomPin");
  const token = getParametersFromLocalStorage("token");
  const dispatch = useDispatch();

  const stepMaster = useSelector((state) => getModuleConfiguration(state));
  const thankYouPage = getStepMaster(
    stepMaster,
    STEP_MASTER_ENUM.CHECKIN_THANKYOU_PAGE
  );

  useEffect(async () => {
    if (thankYouPage && token) {
      const data = {
        PMSConfirmationNo: userData?.pmsConfirmationNo,
        IsSuccess: true,
        StepCode: STEP_MASTER_ENUM.CHECKIN_THANKYOU_PAGE,
        SubStep: "ThankYou",
        AppType: "kiosk",
        SuccessMessage: "Reached thank you page",
        FailureReason: "",
      };

      dispatch(postStageDetails({ data, token }));
    }
  }, [thankYouPage, token]);

  return thankYouPage ? (
    <Thankyou userData={userData} roomPin={roomPin} />
  ) : null;
};

export default ThankyouPassportScan;
